module.exports = __webpack_public_path__ + "media/images/user/1-b8e967d458052eda2e6b4615962073d5.jpg";